import React, { useCallback, useMemo } from "react";

import PDFTablePage from "../../themed/pdf/pdfTablePage";
import CustomSection from "../custom-general/custom-section";

import { PDOChecklistItem } from "./pdoCheckList";
import { Column } from "../../../utils/models";

interface Props {
    generalChecklistItems: PDOChecklistItem[];
    vesselChecklistItems: PDOChecklistItem[];
    pipingChecklistItems: PDOChecklistItem[];
    structuresChecklistItems: PDOChecklistItem[];
}

const PDOSummary: React.FC<Props> = ({ generalChecklistItems, vesselChecklistItems, pipingChecklistItems, structuresChecklistItems }) => {
    const getPDOSummaryRow = useCallback((items: PDOChecklistItem[]) => {
        return items.map((checklist, index) => ({
            id: index + 1,
            hasAnomalies: checklist.hasAnomalies,
            label: checklist.label,
            count: checklist.anomalyItems.length,
        }));
    }, []);

    const generalChecklist = useMemo(() => {
        return getPDOSummaryRow(generalChecklistItems);
    }, [getPDOSummaryRow, generalChecklistItems]);
    
    const vesselChecklist = useMemo(() => {
        return getPDOSummaryRow(vesselChecklistItems);
    }, [getPDOSummaryRow, vesselChecklistItems]);
    
    const pipingChecklist = useMemo(() => {
        return getPDOSummaryRow(pipingChecklistItems);
    }, [getPDOSummaryRow, pipingChecklistItems]);
    
    const structuresChecklist = useMemo(() => {
        return getPDOSummaryRow(structuresChecklistItems);
    }, [getPDOSummaryRow, structuresChecklistItems]);

    return (
        <>
            <CustomSection sectionTitle="Summary Sheet" sectionSubtitle="General">
                <div className="p-1">
                    <PDFTablePage data={generalChecklist} columns={COLUMNS} />
                </div>
            </CustomSection>
            
            <CustomSection sectionTitle="Summary Sheet" sectionSubtitle="Vessel & Equipment">
                <div className="p-1">
                    <PDFTablePage data={vesselChecklist} columns={COLUMNS} />
                </div>
            </CustomSection>
            
            <CustomSection sectionTitle="Summary Sheet" sectionSubtitle="Piping">
                <div className="p-1">
                    <PDFTablePage data={pipingChecklist} columns={COLUMNS} />
                </div>
            </CustomSection>
            
            <CustomSection sectionTitle="Summary Sheet" sectionSubtitle="Structures">
                <div className="p-1">
                    <PDFTablePage data={structuresChecklist} columns={COLUMNS} />
                </div>
            </CustomSection>
        </>
    );
};

const COLUMNS: Column[] = [
    {
        path: 'id',
        label: 'Sr. No',
    },
    {
        path: 'label',
        label: 'Description',
        style: () => ({ textAlign: 'left' })
    },
    {
        path: 'hasAnomalies',
        label: 'Has Anomalies',
        style: () => ({ textTransform: 'capitalize' })
    },
    {
        path: 'count',
        label: 'Number of Anomalies',
    },
];
 
export default PDOSummary;